import { render, staticRenderFns } from "./IndicadoresResumoPreditivaArmazem.vue?vue&type=template&id=0d934808&scoped=true&"
import script from "./IndicadoresResumoPreditivaArmazem.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoPreditivaArmazem.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoPreditivaArmazem.vue?vue&type=style&index=0&id=0d934808&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d934808",
  null
  
)

export default component.exports